import styles from './../var/styleMap';
import customSelect from 'custom-select';
import scrollIt from '../utils/scrollIt';


export default class ArchiveMember {
    
    static get selector() {
        return '.archiveMember';
    }

    constructor(el) {
        //elements 
        this.el = el;
        this.list = this.el.querySelector('.amList')
        this.mapEl = this.el.querySelector('.archiveMember__map');
        this.form = this.el.querySelector('.archiveMember__filterForm');
        this.select= customSelect('.archiveMember__filterSelect')[0];

    
        //map
        this.hasMap = false;
        this.styles = styles;
        this.defaultCenter = {
            lat : 57.5, 
            lng : -10.0
        };
        this.defaultZoom = 4;

        this.countries = this.getCountries();
        this.members = this.getMembers();


        this.setEvents();

        if(window.mapsLoaded) this.initMap();
        else window.addEventListener('ecta-mapsloaded',(e) => {this.initMap()}, false);
    }

    getCountries() {
        let elements = this.form.querySelectorAll('.archiveMember__filterItem');
        let items = [];

        elements.forEach(element => {
            let item = {};
                item.isActive = false;
                item.el = element;
                item.value = element.value;
                item.count = 0;
                item.lat = parseFloat(element.dataset.lat);
                item.lon = parseFloat(element.dataset.lon);
            items.push(item);
        });

        return items;
    }

    getMembers() {
        let elements = this.el.querySelectorAll('.cardMember');
        let items = [];

        elements.forEach(element => {
            let item = {};
                item.el = element;
                item.countries = JSON.parse(element.dataset.country);
                item.toggle = item.el.querySelector('.cardMember__showMore');
                item.isOpen = false;
                item.isActive = false;
            items.push(item);

            // Increase count on country
            item.countries.forEach(country => {
                this.countries.forEach(countryObject => {
                    if(countryObject.value === country) countryObject.count +=1; 
                });
            });
        });

        return items;

    }

    initMap() { 
        if(window.innerWidth <= 650) return;
        this.map = this.createMap();
        this.markers = this.getMarkers();
        this.hasMap = true;

        google.maps.event.addListenerOnce(this.map, 'tilesloaded', () => {
            this.mapEl.classList.add('archiveMember__map--active');
        });
    }

    createMap() {
        return new google.maps.Map(this.mapEl, {
            center: this.defaultCenter,
            styles: this.styles,
            zoom: this.defaultZoom,
            disableDefaultUI: true,
            mapTypeId: 'terrain',
        });
    }

    getMarkers() {

        let icon = {
            path:"M38,19.1C38,35.5,19,50,19,50S0,36.3,0,19.1C0,8.6,8.5,0,19,0S38,8.6,38,19.1z",
            fillColor: '#66CCCC',
            fillOpacity: 1,
            origin: new google.maps.Point(0,0),
            anchor: new google.maps.Point(39/2,50),
            scaledSize: new google.maps.Size(39,50),
            strokeWeight: 0,
            labelOrigin: new google.maps.Point(38/2, 22),
            labelClass: 'marker-label',
            scale: 1
        };

        let markers = [];
        this.countries.forEach(country => {
            let marker = new google.maps.Marker({
                position: {
                    lat: country.lat, 
                    lng: country.lon
                }, 
                label: {
                    text: country.count.toString(),
                    fontWeight: '600',
                    fontSize: '18px',
                    fontFamily: 'ModernEra, sans-serif',
                    color: '#1A5A82',
                    opacity: 0,
                },
                icon: icon,
                map: this.map
            });
            country.marker = marker;
            markers.push(marker);
            marker.addListener('click', () => { this.toggle(country); });
        });
        return markers;
    }



    toggle(country) {
        if(!country.isActive) {
            this.active(country);
            //this.zoomOn(country);
            scrollIt(this.list.offsetTop, 800, 'easeInOutCubic');
            setTimeout(()=>{
                this.zoomOn(country);
            }, 800);
        }
        else {
            this.desactiveAll();
            this.zoomStandard();
        };

        this.filterMembers();

    }

    active(country) {
        if(country.isActive) return;
        this.desactiveAll();
        this.select.value = country.value;
        country.isActive= true;
    }

    desactive(country, changeMap = true) {
        if(!country.isActive) return;
        this.select.value = '';
        country.isActive= false;
    }

    desactiveAll() {
        this.countries.forEach(country =>{
            if(country.isActive) this.desactive(country, false);
        });
    }

    getActiveCountries() {
        let countries = this.countries.filter(country => {
            return country.isActive;
        });
        return countries.map(country => country.value);
    }
    findCountryByName(name) {
        let result = this.countries.filter(country => {
            return country.value === name;
        })
        if(result)return result[0];
    }

    zoomStandard() {
        this.map.setZoom(this.defaultZoom);
        this.map.panTo(this.defaultCenter);
    }

    zoomOn(country) {
        this.map.setZoom(6);
        this.map.panTo(country.marker.getPosition());
    }

    fadeOutCards() {
        return new Promise((resolve, reject) => {
            this.list.classList.add('amList--fadeout');
            setTimeout(resolve, 200);
        })
    }

    fadeInCards() {
        return new Promise((resolve, reject) => {
            this.list.classList.remove('amList--fadeout');
            setTimeout(resolve, 200);
        })
    }

    filterMembers() {
        let activeCountries = this.getActiveCountries();
        if(activeCountries.length){
            let count = 0;

            this.fadeOutCards().then(() => {
                this.list.classList.add('amList--filtered');
                this.members.forEach(member => {
                    let match = activeCountries.filter(value => member.countries.includes(value))
                    if(match.length > 0){
                        this.activeMember(member, count);
                        count++;
                    }
                    else{
                        this.desactiveMember(member);
                    }
                });

                setTimeout(()=>{
                    this.fadeInCards();
                }, 50);
            });
        }
        else{
            this.fadeOutCards().then(() => {
                this.list.classList.remove('amList--filtered');
                this.members.forEach(this.resetMember);
                setTimeout(()=>{
                    this.fadeInCards();
                }, 50);
            });
        }
    }

    activeMember(member, count){
        member.el.classList.add('cardMember--active');
        member.el.classList.remove('cardMember--unactive');
        member.el.setAttribute('data-count', count);
    }
    desactiveMember(member){
        member.el.classList.remove('cardMember--active');
        member.el.classList.add('cardMember--unactive');
        member.el.removeAttribute('data-count');
    }
    resetMember(member){
        member.el.classList.remove('cardMember--active');
        member.el.classList.remove('cardMember--unactive');
        member.el.removeAttribute('data-count'); 
    }

    setEvents() {
        window.addEventListener('resize', this.e_resize.bind(this));
        this.select.select.addEventListener('change', this.e_selectChange.bind(this));
    }

    e_resize(e) {
        if(window.mapsLoaded && (!this.hasMap) && window.innerWidth > 650 ){
            this.initMap();
        }
    }

    e_selectChange(e) {
        if(e.target.value === ''){
            this.desactiveAll();
            this.zoomStandard();
        }else{
            let country = this.findCountryByName(e.target.value)
            if(country && (!country.isActive)){
                this.active(country);
                this.zoomOn(country);
            }
        }
        this.filterMembers();
    }

    e_mapsLoaded() {
        this.initMap();
    }

}